import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import {
  checkUserAccess,
  formatTo12HourTime,
  handleStatus,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector } from "react-redux";
import Logs from "../../Logs/Logs";
import { Modal, ModalBody, Spinner } from "reactstrap";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";

export default function AdminOdRequestDetail() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const location = useLocation();
  const { id } = useParams();
  const [odRequestData, setOdRequestData] = useState({});
  const [refreshLogs, setRefreshLogs] = useState(false);
  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getOdRequests();
  }, []);

  const getOdRequests = () => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_od_details + `?odRequestId=${id}`;
    setIsLoading(true);
    callApi(Url, options).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        setOdRequestData(res?.data);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const HandleApprove_Reject = () => {
    let newStatus;
    if (actionType === "approve") {
      newStatus = 1;
    } else if (actionType === "reject") {
      newStatus = 2;
    }
    const submitData = {
      type: "odRequest",
      id: odRequestData?.id,
      status: newStatus,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    setIsSubmitting(true);
    callApi(API, options)
      .then((response) => {
        setIsSubmitting(false);
        if (response?.status === true) {
          toast.success(response?.message);
          setConfirmModal(false);
          getOdRequests();
          setRefreshLogs(true);
        } else {
          toast.error(response?.message);
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        toast.error(err?.message || "Something went wrong");
      });
  };

  const uniqueSiteTypes = [
    ...new Set(
      odRequestData?.user?.usersites
        ?.map((item) => item.site.type)
        .filter(Boolean)
    ),
  ];

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button className="btn back-arrow" onClick={handleBack}>
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">O.D. Detail</h1>
            </div>
          </div>
          <div className="card manage-user-list">
            <div className="card-body">
              <ul
                className={
                  isLoading
                    ? "row list-unstyled mt-4 loading-skeleton"
                    : "row list-unstyled mt-4"
                }
              >
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Emp. Code :</span>
                    {odRequestData?.user?.employeeCode || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Emp. Name :</span>
                    {odRequestData?.user?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Status :</span>
                    {handleStatus(odRequestData?.status) || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Department :
                    </span>
                    {odRequestData?.user?.department?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Designation :
                    </span>
                    {odRequestData?.user?.designation?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      {odRequestData?.user?.type == 1 && " Office :"}
                      {odRequestData?.user?.type == 0 && " Site :"}
                    </span>
                    {odRequestData?.user?.type == 1
                      ? odRequestData?.user?.site?.name
                      : odRequestData?.user?.type == 0
                        ? odRequestData?.user?.usersites?.[0]?.site?.name
                        : "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Site Type :</span>
                    {uniqueSiteTypes.join(", ")}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Mode of Communication :
                    </span>
                    {odRequestData?.communicationMode || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Client Name :
                    </span>
                    {odRequestData?.clientName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Contact Person :
                    </span>
                    {odRequestData?.contactPersonName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Contact Number :
                    </span>
                    {odRequestData?.phoneNumber || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Location :</span>
                    {odRequestData?.locationName || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Start Date :
                    </span>
                    {(odRequestData?.startDate &&
                      moment(odRequestData?.startDate).format("DD-MM-YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">End Date :</span>
                    {(odRequestData?.endDate &&
                      moment(odRequestData?.endDate).format("DD-MM-YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Reason :</span>
                    {odRequestData?.reason || "--"}
                  </p>
                </li>

                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Remark :</span>
                    {odRequestData?.remark || "--"}
                  </p>
                </li>
                {/* {odRequestData?.user?.type == 0 ? (
                  ""
                ) : (
                  <li className="col-12 col-md-6 col-lg-4">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Assigned Sites :
                      </span>
                      <ul className="list-unstyled">
                        {odRequestData?.user?.usersites?.length > 0
                          ? odRequestData?.user?.usersites?.map(
                              (userSite, index) => (
                                <li key={userSite.id || index}>
                                  {userSite.site?.name || "--"}
                                </li>
                              )
                            )
                          : "-"}
                      </ul>
                    </p>
                  </li>
                )} */}
              </ul>
            </div>
            {((checkUserAccess(userDetails).isUserAccess &&
              location?.state?.type === "request" &&
              userDetails?.type !== 2) ||
              location?.state?.type === "teamRequest") && (
                <div className="card-body d-flex justify-content-end">
                  <div className="col-12 col-md-6 col-lg-4 ">
                    <span className="d-flex align-items-center gap-3 justify-content-end">
                      {odRequestData?.status == 0 && (
                        <>
                          <button
                            className="btn btn-success "
                            onClick={() => {
                              setActionType("approve");
                              setConfirmModal(true);
                            }}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-danger px-4"
                            onClick={() => {
                              setActionType("reject");
                              setConfirmModal(true);
                            }}
                          >
                            Reject
                          </button>
                        </>
                      )}
                    </span>
                  </div>
                </div>
              )}
          </div>
        </div>
        <Logs
          type={"odRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
        <Modal
          isOpen={confirmModal}
          toggle={() => setConfirmModal(!confirmModal)}
          centered
        >
          <ModalBody className="text-center">
            <div className="d-flex flex-column justify-content-center align-items-center gap-4">
              <span className={actionType === "reject" ? "icon" : "icon success"}>
                {actionType === "reject" ? <CrossIcon /> : <CheckIcon />}
              </span>
              <p className="mb-4">
                Do you really want to {actionType === "reject" ? "Reject" : "Approve"} this request?
              </p>

              {/* Buttons */}
              <div className="row m-0 w-100">
                <div className="col-12 col-md-6 ps-0 pe-3">
                  <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={() => setConfirmModal(false)}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-12 col-md-6 pe-0 ps-3">
                  <button
                    className={`btn ${actionType === "reject" ? "btn-danger" : "btn-success"} w-100`}
                    onClick={HandleApprove_Reject}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner size="sm" color="light" />
                    ) : actionType === "reject" ? (
                      "Reject"
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    </>
  );
}
